import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../../atoms';

import { TreatmentHistoryTable } from './TreatmentHistoryTable';

export const TreatmentHistorySection = () => {
  const currentPlan = useAtomValue(selectedPlanAtom);

  // Only show data if we have valid treatment history data
  if (
    !currentPlan?.treatmentHistoryV2 ||
    currentPlan.treatmentHistoryV2.length === 0 ||
    !currentPlan.treatmentHistoryV2.some((item) => item.procedures.length > 0)
  ) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8 vai-bg-gray-50 vai-rounded-lg">
        <Trans>
          No treatment history data available for the selected plan.
        </Trans>
      </div>
    );
  }

  return <TreatmentHistoryTable data={currentPlan.treatmentHistoryV2} />;
};
